module Meevo.Plugins.Register {
    "use strict";
    export enum ClientAccountSaleStageEnum {
        Initial = 0,
        Credit = 1,
        Payment = 2,
        Refund = 3
    }

    export class ClientAccountsSection extends Meevo.Plugins.Register.RegisterSectionBase {
        balance: number = 0;
        originalBalance: number = 0;
        allowChargesCreditOnAccount: boolean = false;
        client: Model.ClientListItem;
        stage: ClientAccountSaleStageEnum;
        saleLine: Model.SaleLine;
        additionalCreditSaleLine: Model.SaleLine;
        amount: number = 0;
        originalAmount: number = 0;
        isEditing: boolean = false;
        refundTotal: number;

        get $q() { return this.registerContext.$q; }
        get $translate() { return this.registerContext.$translate; }
        get $filter() { return this.registerContext.$filter; }

        get dataService() { return this.registerContext.dataService; }
        get modalService() { return this.registerContext.modalService; }

        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(RegisterSectionTypeEnum.ClientAccounts, registerContext, "clientAccounts", Register.RegisterSectionCatTypeEnum.Sale);
        }

        clientSelected() {
            if (!this.isClientDisabled()) {
                this.reset();
            }
        }

        switchToServicesWhenClientSelected() {
            return false;
        }

        clientChanged() {
            if (angular.isDefined(this.client)) {
                let existingSaleLine;

                if (this.stage == ClientAccountSaleStageEnum.Refund) {
                    existingSaleLine = _(this.registerContext.sale.saleLines).find((saleLine: Model.SaleLine) => {
                        return saleLine.isRefund && saleLine.saleType == Model.SalesTypeEnum.ClientAccountCredit &&
                            (<ClientAccountSaleLineItem>saleLine.item).id == this.client.id;
                    });
                }
                if (angular.isDefined(existingSaleLine)) {
                    this.edit(existingSaleLine);
                } else {
                    this.getBalance()
                }
            }
        }

        reset() {
            this.registerContext.hideCheckoutButtons = false;
            this.isEditing = false;
            this.additionalCreditSaleLine = undefined;
            this.amount = 0;
            this.originalAmount = 0;
            this.stage = this.registerContext.isRefundMode 
                ? ClientAccountSaleStageEnum.Refund 
                : ClientAccountSaleStageEnum.Initial;
            this.client = this.registerContext.selectedClientType == Model.ClientTypeEnum.Client 
                ? this.registerContext.selectedClient 
                : undefined;
            this.clientChanged();
        }

        clear() {
            this.amount = 0;
        }

        save(isValid) {
            if (this.amount === 0) {
                return;
            }

            if (!this.allowChargesCreditOnAccount) {
                let message;
                if (this.stage == ClientAccountSaleStageEnum.Credit) {
                    message = "LABEL_CLIENT_ACCOUNT_NOT_ENABLED";
                }
                else if (this.additionalCreditWillBeCreated()) {
                    message = 'LABEL_CLIENT_ACCOUNT_NOT_ENABLED_EXCESS_PAYMENT';
                }
                if (angular.isDefined(message)) {
                    this.modalService.alert(message).then(() => {
                        this.amount = 0;
                    });

                    return;
                }
            }

            this.checkOverPayment().then(response => {
                if (response) {

                    if (this.isEditing) {
                        // if decreasing payment amount so there's essentially not enough, rather than trying to move some off of an existing credit,
                        // just blow away all the credits.
                        if (this.stage === ClientAccountSaleStageEnum.Payment && this.additionalCreditAmount() < 0) {
                            this.deleteCreditSaleLines();
                        }
                    }
                    else {
                        this.saleLine.employeeId = this.registerContext.HouseEmployee.id;
                        this.saleLine.employee = this.registerContext.HouseEmployee;
                        this.registerContext.sale.saleLines.push(this.saleLine);
                    }
                    if (this.additionalCreditSaleLine) {
                        this.additionalCreditSaleLine.employeeId = this.saleLine.employeeId;
                        this.additionalCreditSaleLine.employee = this.saleLine.employee;
                        this.registerContext.sale.saleLines.push(this.additionalCreditSaleLine);
                    }
                    this.registerContext.recalculateSale().then(() => {
                        this.reset();
                    });
                } else {
                    this.amount = 0;
                }
            });
        }

        newBalance() {
            return Number(this.amount) + this.balance;
        }

        amountChange() {
            return this.amount - this.originalAmount;
        }

        additionalCreditAmount() {
            return this.isEditing ? this.amountChange() : this.newBalance();
        }

        additionalCreditWillBeCreated() {
            return this.stage === ClientAccountSaleStageEnum.Payment && this.newBalance() > 0 && this.amountChange() > 0;
        }

        deleteCreditSaleLines() {
            for (let i = this.registerContext.sale.saleLines.length - 1; i >= 0; i--) {
                let saleLine = this.registerContext.sale.saleLines[i];
                if (saleLine.saleType == Model.SalesTypeEnum.ClientAccountCredit && (<ClientAccountSaleLineItem>saleLine.item).id == this.client.id) {
                    this.registerContext.sale.saleLines.splice(i, 1);
                }
            }
        }

        checkOverPayment() {
            let defer = this.$q.defer();

            if (this.additionalCreditWillBeCreated()) {
                let meevoCurrency: any = this.$filter('meevoCurrency');
                let message = this.$translate.instant("MESSAGE_CLIENT_ACCOUNT_OVERPAYMENT", {
                    creditAmount: meevoCurrency(this.additionalCreditAmount())
                });
                return this.modalService.okCancelHandler(message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate).then((response) => {
                    if (response) {
                        var existingCreditLine = this.getExistingCreditLine();
                        if (existingCreditLine) {
                            existingCreditLine.baseItemPrice += this.additionalCreditAmount();
                            existingCreditLine.finalItemPrice += this.additionalCreditAmount();
                        } else {
                            this.additionalCreditSaleLine = this.createSaleLine(Model.SalesTypeEnum.ClientAccountCredit, (<ClientAccountSaleLineItem>this.saleLine.item).originalBalance);
                            this.additionalCreditSaleLine.baseItemPrice = this.additionalCreditAmount();
                            this.additionalCreditSaleLine.finalItemPrice = this.additionalCreditAmount();
                        }
                        this.saleLine.baseItemPrice = this.amount - this.additionalCreditAmount();
                        this.saleLine.finalItemPrice = this.amount - this.additionalCreditAmount();
                    }
                    return response;
                });
            } else {
                this.saleLine.baseItemPrice = this.stage == ClientAccountSaleStageEnum.Refund ? this.amount * -1 : this.amount;
                this.saleLine.finalItemPrice = this.saleLine.baseItemPrice;
                defer.resolve(true);
                return defer.promise;
            }
        }

        getExistingCreditLine() {
            return _(this.registerContext.sale.saleLines).find((saleLine: Model.SaleLine) => {
                if (saleLine.saleType == Model.SalesTypeEnum.ClientAccountCredit && (<ClientAccountSaleLineItem>saleLine.item).id == this.client.id &&
                    ((this.saleLine.clientType == Model.ClientTypeEnum.Client && saleLine.clientId == this.saleLine.clientId) ||
                        (this.saleLine.clientType != Model.ClientTypeEnum.Client && saleLine.clientType == this.saleLine.clientType))) {
                    return true;
                }
                return false;
            });
        }

        getBalance() {
            this.dataService.getItem("client", new Guid(this.client.id), "accountbalance").then((accountBalance: any) => {
                this.originalBalance = accountBalance.accountBalance;
                this.balance = +accountBalance.accountBalance;
                this.allowChargesCreditOnAccount = accountBalance.allowChargesCreditOnAccount;
                this.getClientAccountSaleLinesForClient(this.client.id, (saleLine) => {
                    this.balance += +saleLine.baseItemPrice;
                });
                this.balance = this.registerContext.normalizeDecimalPlaces(this.balance);
            });
        }

        getClientAccountSaleLinesForClient(clientId, matchingSaleLineAction = undefined) {
            let matchingSaleLines = [];
            this.registerContext.sale.saleLines.forEach((saleLine) => {
                if ((saleLine.saleType == Model.SalesTypeEnum.ClientAccountCredit || saleLine.saleType == Model.SalesTypeEnum.ClientAccountPayment) && (<ClientAccountSaleLineItem>saleLine.item).id == clientId) {
                    matchingSaleLines.push(saleLine);
                    if (matchingSaleLineAction) {
                        matchingSaleLineAction(saleLine);
                    }
                }
            });
            return matchingSaleLines;
        }

        credit() {
            this.registerContext.hideCheckoutButtons = true;
            this.stage = ClientAccountSaleStageEnum.Credit;
            this.saleLine = this.createSaleLine(Model.SalesTypeEnum.ClientAccountCredit, this.originalBalance);
        }

        payment() {
            this.registerContext.hideCheckoutButtons = true;
            this.stage = ClientAccountSaleStageEnum.Payment;
            this.saleLine = this.createSaleLine(Model.SalesTypeEnum.ClientAccountPayment, this.originalBalance);
        }

        initialStage = () => {
            this.registerContext.hideCheckoutButtons = false;
            this.stage = ClientAccountSaleStageEnum.Initial;
        }

        private getDisplayName(saleType: Model.SalesTypeEnum): string {
            let clientAccountDesc = null;

            switch (saleType) {
                case Model.SalesTypeEnum.ClientAccountCredit:
                    clientAccountDesc = this.stage === ClientAccountSaleStageEnum.Refund 
                        ? this.$translate.instant("LABEL_CLIENT_ACCOUNT_REFUND") 
                        : this.$translate.instant("LABEL_CLIENT_ACCOUNT_CREDIT_FOR");
                    break;
                case Model.SalesTypeEnum.ClientAccountPayment:
                    clientAccountDesc = this.$translate.instant("LABEL_CLIENT_ACCOUNT_PAYMENT_FOR");
                    break;
                case Model.SalesTypeEnum.DepositCredit:
                    clientAccountDesc = this.stage === ClientAccountSaleStageEnum.Refund 
                        ? this.$translate.instant("LABEL_DEPOSIT_REFUND") 
                        : this.$translate.instant("LABEL_DEPOSIT_FOR");
                    break;
            }

            if (clientAccountDesc) {
                return `${clientAccountDesc}: ${this.client.displayName}`;
            }

            return null;
        }

        createSaleLine(saleType: Model.SalesTypeEnum, originalBalance: number) {
            let saleLineItem = new Meevo.Plugins.Register.ClientAccountSaleLineItem({
                id: this.client.id,
                client: this.client,
                clientId: this.client.id,
                originalBalance: originalBalance,
                displayName: this.getDisplayName(saleType),
            });
            
            let saleLine: Model.SaleLine = {
                item: saleLineItem,
                quantity: 1,
                client: this.isEditing ? this.saleLine.client : this.registerContext.selectedClient,
                clientId: this.isEditing ? this.saleLine.clientId : (this.registerContext.selectedClient ? this.registerContext.selectedClient.id : undefined),
                clientType: this.isEditing ? this.saleLine.clientType : this.registerContext.selectedClientType,
                saleType: saleType,
                isNew: this.registerContext.selectedClientType === Model.ClientTypeEnum.Client,
                isRefund: this.stage == ClientAccountSaleStageEnum.Refund,
                showPoleMessage: Model.SaleLineStatusEnum.Added
            };

            return saleLine;
        }

        headerContentKey() {
            switch (this.stage) {
                case ClientAccountSaleStageEnum.Payment:
                    return 'LABEL_MAKE_ACCOUNT_PAYMENT';
                case ClientAccountSaleStageEnum.Credit:
                    return 'LABEL_PLACE_CREDIT_ACCOUNT';
                case ClientAccountSaleStageEnum.Refund:
                    return 'LABEL_ACCOUNT_CREDIT_REFUND';
                default:
                    return 'LABEL_ACCOUNT_PAYMENTS_CREDITS';
            }
        }

        edit(saleLine: Model.SaleLine) {
            this.registerContext.hideCheckoutButtons = true;
            this.isEditing = true;
            this.additionalCreditSaleLine = undefined;
            this.originalAmount = saleLine.baseItemPrice;
            this.stage = saleLine.isRefund ? ClientAccountSaleStageEnum.Refund : (saleLine.saleType == Model.SalesTypeEnum.ClientAccountPayment ? ClientAccountSaleStageEnum.Payment : ClientAccountSaleStageEnum.Credit);
            this.amount = this.stage == ClientAccountSaleStageEnum.Refund ? saleLine.baseItemPrice * -1 : saleLine.baseItemPrice;
            let editClientAccountSaleLineItem = <ClientAccountSaleLineItem>saleLine.item;
            this.balance = editClientAccountSaleLineItem.originalBalance;
            this.getClientAccountSaleLinesForClient(editClientAccountSaleLineItem.id, (saleLine) => {
                this.balance += Number(saleLine.baseItemPrice);
            });
            this.balance -= Number(saleLine.baseItemPrice);
            this.saleLine = saleLine;
            this.client = editClientAccountSaleLineItem.client || {
                id: editClientAccountSaleLineItem.clientId,
                displayName: editClientAccountSaleLineItem.clientDisplayName
            };
        }

        delete(saleLine: Model.SaleLine) {
            if (this.isClientAccountSaleLine(saleLine)) {
                if (saleLine.saleType === Model.SalesTypeEnum.ClientAccountPayment) {
                    this.deleteCreditSaleLines();
                }
                if (angular.isDefined(this.client) && (<ClientAccountSaleLineItem>saleLine.item).id == this.client.id) {
                    this.reset();
                }
            }
        }

        isClientAccountSaleLine(saleLine) {
            return saleLine.saleType === Model.SalesTypeEnum.ClientAccountPayment || saleLine.saleType === Model.SalesTypeEnum.ClientAccountCredit;
        }

        isPlaceCreditDisabled() {
            return !this.client || this.balance < 0;
        }

        isMakePaymentDisabled() {
            return !this.client || this.balance >= 0;
        }

        amountChanged() {
            if (this.stage == ClientAccountSaleStageEnum.Refund) {
                this.refundTotal = +this.amount;
            }
        }

        applyRefundItems() {
            if (angular.isUndefined(this.client)) {
                return;
            }
            if (this.amount > this.balance) {
                this.modalService.alert("MESSAGE_ACCOUNT_CREDIT_REFUND");
                return;
            }
            if (!this.isEditing) {
                this.saleLine = this.createSaleLine(Model.SalesTypeEnum.ClientAccountCredit, this.originalBalance);
            }
            this.save(true);
        }

        isClientDisabled() {
            return this.isEditing;
        }
    }
}